/*
 * Dmitrii 2022-05-19: I've changed assets/custom.js.liquid file to stop using liquid code to be able to minify it.
 * Everything we need to pass from liquid to JavaScript should be added to window.theme in layout/theme.liquid
 * I use Babel version 7.11.6 (latest) to do the minification: https://babeljs.io/setup
*/

/*#########################################################*/
/*############### Custom JS by beeclever ##################*/
/*#########################################################*/

window.bcAddToCart = (addData) => {
    fetch('/cart/add.js', {
            body: JSON.stringify(addData),
            credentials: 'same-origin',
            headers: {'Content-Type': 'application/json', 'Accept':'application/json', 'X-Requested-With': 'XMLHttpRequest'},
            method: 'POST'
        }).then(function(response) {
            if(!response.ok) {
                response.text().then(text => {
                    let error = JSON.parse(text);
                    console.error(error.status);
                    console.error(error.message);
                    console.error(error.description);
                })
            } else {
               return response.json();
            }
        }).then(function(product) {
            document.dispatchEvent(new CustomEvent('cart:build'));
            document.dispatchEvent(new CustomEvent('cart:open'));
        }).catch(function(err) {
            console.error(err);
        }
    );
}

window.bcUpdateCart = (updateData) => {
    fetch('/cart/update.js', {
        body: JSON.stringify(updateData),
        credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', 'Accept':'application/json', 'X-Requested-With': 'XMLHttpRequest'},
        method: 'POST'
    }).then(function(response) {
        if(!response.ok) {
            //console.log("error update");
            response.text().then(text => {
                let error = JSON.parse(text);
                console.error(error.status);
                console.error(error.message);
                console.error(error.description);
            })
        } else {
            return response.json();
        }
    }).then(function(product) {
        //console.log("Complete update");
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:open'));
    }).catch(function(err) {
            console.error(err);
        }
    );
}

window.bcSingleAddToCart = (e) => {
    e.preventDefault();
    const btn = e.currentTarget;
    window.bcAddToCart({
        items:[
            {
                id: Number(btn.getAttribute('data-variant-id')),
                quantity:1
            }
        ]
    })
    if(btn.hasAttribute('data-quick-variant-selector')){
        document.querySelector('#quick-variant-selector-'+btn.getAttribute('data-quick-variant-selector')).checked = false;
    }
}
/*######################################################################################*/
/*############################## Free shipping & Free gift #############################*/
/*######################################################################################*/

function updateFreeShippingBar() {
    fetch(theme.routes.home + '?section_id=free-shipping-bar')
    .then(response => response.text())
    .then(data => {
        var template = document.createElement('template');
        template.innerHTML = data.trim();
        var firstChild = template.content.firstChild

        document.querySelector('.free-shipping-bar-snippet').innerHTML = firstChild.innerHTML;
    });
}

function removeFreeGiftQuantitySelector() {

    setTimeout(function () {
        var freeGiftVariantId = 0;
        var freeGiftBar = document.querySelector(".free-gift-bar-snippet");

        if ( !!freeGiftBar && !!freeGiftBar.dataset && !!freeGiftBar.dataset.fgVariantId ) {
            freeGiftVariantId = parseInt( freeGiftBar.dataset.fgVariantId );
        }
        if ( freeGiftVariantId !== 0 ) {
            var freeGiftCartRow = document.querySelector ( '[data-key^="' + freeGiftVariantId + ':"]' )
            if ( !!freeGiftCartRow ) {
                var quantitySelector = freeGiftCartRow.querySelector ( '.js-qty__wrapper' );
                if ( !!quantitySelector ) {
                    quantitySelector.remove ();
                }
            }
        }
    }, 500 )
}

function updateFreeGiftBar(){
    fetch(theme.routes.home + '?section_id=free-gift-bar')
    .then(response => response.text())
    .then(data => {
        let div = document.createElement('div');
        div.innerHTML = data.trim();
        document.querySelector('.free-gift-bar-snippet').innerHTML = div.querySelector(".free-gift-bar-snippet").innerHTML;

        //console.log("gift_var_id", div.querySelector(".free-gift-bar-snippet").dataset);
        let fg_variant_id = 0;
        let fg_price_over = false;
        if ("fgVariantId" in div.querySelector(".free-gift-bar-snippet").dataset) {
            fg_variant_id = parseInt(div.querySelector(".free-gift-bar-snippet").dataset.fgVariantId);
        }
        if ("fgPriceOver" in div.querySelector(".free-gift-bar-snippet").dataset) {
            fg_price_over = Boolean(div.querySelector(".free-gift-bar-snippet").dataset.fgPriceOver);
        }

        if (fg_price_over === true) {
            theme.cart.getCart().then(cart => {
                //console.log(cart);
                //console.log("dataset in then", fg_variant_id);
                let fg_price = theme.settings.free_gift_price;
                let cart_price = cart.total_price / 100;
                let fg_product_in_cart = cart.items.some(item => item.variant_id === fg_variant_id);
                let hasGiftCart = cart.items.some(item => item.product_id === 1339794686035 );

                if (cart_price >= fg_price && fg_product_in_cart === false && fg_variant_id !== 0 && hasGiftCart === false ) {
                    let items = new Array();
                    items.push({
                        id: fg_variant_id,
                        quantity:1
                    });
                    //console.log(items);
                    bcAddToCart({items})
                } else if (cart_price < fg_price && fg_product_in_cart && fg_variant_id !== 0) {
                    let updates = {};
                    updates[fg_variant_id] = 0;
                    //console.log(updates);
                    bcUpdateCart({updates});
                }
            });
        }
    });
}

function updateFreeGiftAndFreeShippingBar(){
    updateFreeShippingBar()
    if ( theme.settings.free_gift_enable && ! theme.settings.free_gift_product_is_blank ) {
        updateFreeGiftBar()
    }
}

function addEvents ( callback ) {
  document.addEventListener('cart:updated',callback);
  document.addEventListener('cart:open',callback);
  document.addEventListener('cart:build',callback);
  document.addEventListener('ajaxProduct:added',callback);
}

addEvents(updateFreeGiftAndFreeShippingBar);
addEvents(removeFreeGiftQuantitySelector);
addEvents(updateMinimumShipping);
addEvents(updateMinimumShippingMain);


function updateMinimumShipping() {
    fetch(theme.routes.home + '?section_id=minimum_shipping')
    .then(response => response.text())
    .then(data => {
        var template = document.createElement('template');
        template.innerHTML = data.trim();
        var firstChild = template.content.firstChild

        var target = document.querySelector('.minimum_shipping_price_and_checkout_buttons');
        if(!!target) {
          target.innerHTML = firstChild.innerHTML;
        }

    });
}

function updateMinimumShippingMain() {
    fetch(theme.routes.home + '?section_id=minimum_shipping_main')
    .then(response => response.text())
    .then(data => {
        var template = document.createElement('template');
        template.innerHTML = data.trim();
        var firstChild = template.content.firstChild

        var target = document.querySelector('.minimum_shipping_price_and_checkout_buttons_main');
        if(!!target) {
          target.innerHTML = firstChild.innerHTML;
        }
    });
}

/*#########################################################*/
/*############### Custom JS by Dmitrii ##################*/
/*#########################################################*/

// Dmitrii: my namespace for A/B, custom GA events etc.
window.lizza = window.lizza || {};
window.lizza.DOMReady = function(callback) {
    document.readyState === "interactive" || document.readyState === "complete" ? callback() : document.addEventListener("DOMContentLoaded", callback);
};
window.lizza.windowLoad = function(callback) {
    document.readyState === "complete" ? callback() : window.addEventListener("load", callback);
};
window.lizza.isGetParameter = function(parameterName) {
    let result = null, tmp = [];
    location.search
      .substr(1)
      .split("&")
      .forEach(function (item) {
          tmp = item.split("=");
          if (tmp[0] === parameterName) result = true;
      });
    return result;
};

window.lizza.moveIngredientProductsSectionToDescription = function() {
    let recipe_body = document.querySelector('.article-rezepte .article__body');
    let ingredient_products = document.querySelector('.shopify-section-recipe-products');
    if ( recipe_body && ingredient_products ) {
        let bottom_image = recipe_body.lastElementChild.querySelector('img');
        if ( bottom_image ) {
            let bottom_image_container = recipe_body.lastElementChild;
            recipe_body.insertBefore( ingredient_products, bottom_image_container );
        } else {
            recipe_body.appendChild( ingredient_products );
        }

        window.dispatchEvent(new Event('resize'));
    }
}
window.lizza.DOMReady( window.lizza.moveIngredientProductsSectionToDescription );

window.lizza.makeBlogTableOfContents = function () {
    let body = document.querySelector('.article-blog .article__body');
    let toc = document.querySelector('.table-of-contents');

    if (toc && body) {
        let toc_title = toc.dataset.title || 'Inhalt'; // 'Contents' for English
        let prevent_num = toc.dataset.prevent;
        console.log('prevent: ' + prevent_num);
        // let headers = body.querySelectorAll('h2, h3');
        let headers = body.querySelectorAll('h2');
        if (headers.length) {
            let toc_header = document.createElement('h4');
            toc_header.textContent = toc_title;
            toc.appendChild(toc_header);
        }
        headers.forEach(function(header, index) {
            let index1 = index+1;
            let elm_id = 'toc' + index1;
            // header.id = elm_id;
            let anchor_target = document.createElement('a');
            anchor_target.id = elm_id;
            anchor_target.classList.add('Anchor-toc');
            let parent = header.parentElement;
            parent.insertBefore(anchor_target, header);

            let anchor_link = document.createElement('a');
            anchor_link.href = '#' + elm_id;
            anchor_link.textContent = prevent_num == 1 ? header.innerText : index1 + '. ' + header.innerText;

            let toc_elm = document.createElement('div');
            toc_elm.classList.add(header.nodeName);
            toc_elm.appendChild(anchor_link);

            toc.appendChild(toc_elm);
        });

        // toc.style.float = 'left';
        toc.classList.remove('hide');

        // let hh = document.querySelector('.Header__Wrapper');
        // console.log(hh.offsetHeight);
        // toc.style.position = 'fixed';
        // toc.style.top = hh.offsetHeight + 'px';
        // toc.style.left = 0;
        // console.log(toc);

        // Go To the Top button
        let root = document.querySelector('body');
        if (root) {
            let go_to_top_button = document.createElement('button');
            let left_arm = document.createElement('span');
            left_arm.classList.add('left-arm');
            let right_arm = document.createElement('span');
            right_arm.classList.add('right-arm');
            let arrow_slide = document.createElement('span');
            arrow_slide.classList.add('arrow-slide');
            go_to_top_button.appendChild(left_arm);
            go_to_top_button.appendChild(right_arm);
            go_to_top_button.appendChild(arrow_slide);

            go_to_top_button.classList.add('toc-go-up');
            root.appendChild(go_to_top_button);


            function tocGoToTop() {
                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
            }
            go_to_top_button.addEventListener('click', tocGoToTop);
            function tocScroll() {
                if (document.body.scrollTop > 200 || document.documentElement.scrollTop > 200) {
                    go_to_top_button.classList.add('show');
                } else {
                    go_to_top_button.classList.remove('show');
                }
            }
            window.addEventListener('scroll', tocScroll);

        }
    }
};
window.lizza.DOMReady(window.lizza.makeBlogTableOfContents);

window.lizza.initChangeCollectionAddToCartLayout = function() {
    window.lizza.changeCollectionAddToCartLayout = function () {
        let products = document.querySelectorAll('.collection-content .quick-add-to-cart-wrapper:not(.layout-shifted)');
        products.forEach(function(wrapper) {
            wrapper.parentNode.appendChild(wrapper); // Move ATC wrapper to the bottom of it's parent
            wrapper.classList.add('layout-shifted');

            let button = wrapper.querySelector('.quick-add-to-cart');
            if (button) button.innerText = wrapper.dataset.atcText;


            let vendor = wrapper.parentNode.querySelector('.grid-product__vendor');
            if (vendor) vendor.classList.remove('hide');

            //Equalize button positioning
            let list_item_selector = '.collection-grid__wrapper .grid .grid__item'; //Collection pages
            let elm_to_move_selector = '.quick-add-to-cart-wrapper.layout-shifted .quick-add-to-cart';
            let rowLen = (function () {
                for ( var ii = 0, list = document.querySelectorAll( list_item_selector ),
                        len = list.length, el = 0, ell = 0;
                      ii < len; ii++ ) {
                    el = list[ii].getBoundingClientRect().left;
                    if ( el > ell || 0 === ell ) {
                        ell = el;
                        if (ii+1 === list.length) {
                            return ii+1;
                        }
                    }
                    else { return ii; }
                }
            }());
            // console.log('list_item_selector: ' + list_item_selector);
            // console.log('rowLen: ' + rowLen);

            let list = document.querySelectorAll( list_item_selector );
            // console.log('list: ');
            // console.log(list);
            for (let i = 0; i < list.length; i = i+rowLen) {
                //First loop – see if elements have different height and remember the highest
                let height_max = 0;
                let height_varies = false;
                for (let j = 0; j < rowLen; j++) {
                    let cur_item = list[i+j];
                    // console.log('cur_item:');
                    // console.log(cur_item);
                    if (cur_item) {
                        // console.log('cur_item.offsetHeight: ' + cur_item.offsetHeight);
                        // console.log('height_max: ' + height_max);

                        if ( height_max !== 0 && height_max !== cur_item.offsetHeight ) {
                            height_varies = true;
                        }
                        if (cur_item.offsetHeight > height_max) {
                            height_max = cur_item.offsetHeight;
                        }
                    }
                }

                // console.log('Row ' + i)
                // console.log('height_max: ' + height_max);
                // console.log('height_varies: ' + height_varies);

                //Second loop – make sure all elements in a row have same height
                if( height_varies ) {
                    for (let j = 0; j < rowLen; j++) {
                        let cur_item = list[i+j];
                        if (cur_item) {
                            if (cur_item.offsetHeight < height_max) {
                                let height_diff = Math.abs(height_max - cur_item.offsetHeight);

                                let elm_to_move = cur_item.querySelector(elm_to_move_selector);
                                if (elm_to_move) {
                                    elm_to_move.style.marginTop = parseInt(getComputedStyle(elm_to_move).marginTop) + height_diff + 'px';
                                }
                            }
                        }
                    }
                }
            }

        });
    };
    window.lizza.DOMReady(window.lizza.changeCollectionAddToCartLayout);
};
window.lizza.ajaxinateCallback = function() {
    if (typeof window.lizza.changeCollectionAddToCartLayout === "function") {
        window.lizza.changeCollectionAddToCartLayout();
    }

    /* On search results page move product results above other types */
    if (typeof window.lizza.searchResultsPutProductsFirst === "function") {
        window.lizza.searchResultsPutProductsFirst();
    }
}

window.lizza.changePDPlayout = function() {
    let button = document.querySelector('.product-single__form .add-to-cart');
    if (button) {
        let span = button.querySelector('span[data-add-to-cart-text]');
        if (span) {
            span.innerText = span.dataset.atcText;
            button.classList.add('layout-shifted');
        }
    }
};

if (window.lizza.isGetParameter('changeCollectionAddToCartLayout') ) {
    lizza.DOMReady(window.lizza.initChangeCollectionAddToCartLayout);
}

if (window.lizza.isGetParameter('changePDPlayout') ) {
    lizza.DOMReady(window.lizza.changePDPlayout);
}

window.lizza.highlightSaleLink = function() {
    let saleLinks = document.querySelectorAll('.nav__link-sale');
    saleLinks.forEach(function(elm){
        elm.classList.add('color-red');
    });
};
if (window.lizza.isGetParameter('highlightSaleLink') ) {
    lizza.DOMReady(window.lizza.highlightSaleLink);
}

window.lizza.makeATCButtonStickyOnPDP = function() {
    // console.log('window.lizza.makeATCButtonStickyOnPDP invoked');
    let atc = document.querySelector('.template-product div[data-product-blocks] button.add-to-cart');
    if (atc) {
        let elmToMakeSticky = atc.closest('.product-block:not(.product-block .product-block)');
        if (elmToMakeSticky) {
            elmToMakeSticky.style.position = 'sticky';
            elmToMakeSticky.style.bottom = '1em';
            // console.log('window.lizza.makeATCButtonStickyOnPDP: success')
        } else {
            console.error('window.lizza.makeATCButtonStickyOnPDP: could not find elmToMakeSticky')
        }
    } else {
        console.error('window.lizza.makeATCButtonStickyOnPDP: could not find atc')
    }
};
window.lizza.showExtendedPDP = function() {
    let container = document.querySelector('.template-product .tabs');
    if (container) {
        /* Move reviews to one of the tabs */
        let reviews_widget = document.querySelector('[data-oke-reviews-widget]');
        let reviews_tab = document.querySelector('.tabs .tab-content#product-ratings');
        if (reviews_widget && reviews_tab) {
            let reviews_index_section = reviews_widget.closest('.index-section');
            let reviews_wrapper = reviews_widget.closest('.shopify-section');
            if (reviews_wrapper) {
                reviews_tab.appendChild(reviews_wrapper);
            }
        }

        /* Hide native tabs */
        let native_tabs = document.querySelectorAll('.product-block.product-block--tab');
        native_tabs.forEach(function(elm){
            elm.classList.add('hide');
        });

        container.classList.remove('hide');
        window.lizza.makeATCButtonStickyOnPDP();
    }
};
lizza.DOMReady(window.lizza.showExtendedPDP);

window.lizza.removeFeaturedProductAndFeaturedCollection = function() {
    let unique_element_for_featured_product = document.querySelector('.template-index .page-content--product');
    if (unique_element_for_featured_product) {
        let featured_product_section = unique_element_for_featured_product.closest('.section-featured-product');
        featured_product_section.parentElement.removeChild(featured_product_section);
    }
    let unique_element_for_featured_collection = document.querySelector('.template-index [data-collection-handle="main_page_featured"]');
    if (unique_element_for_featured_collection) {
        let featured_collection_section = unique_element_for_featured_collection.closest('.section-featured-collection');
        featured_collection_section.parentElement.removeChild(featured_collection_section);
    }
};
if (window.lizza.isGetParameter('indexHide') ) {
    lizza.DOMReady(window.lizza.removeFeaturedProductAndFeaturedCollection);
}

window.lizza.replaceMainProductImage = function() {

    let replaceImageSource = function(elm, newUrl) {
        if ( elm.hasAttribute('srcset') ) {
            let widthsArr = elm.getAttribute('data-widths').replace(/[\[\]\s]/gm, '').split(',').map(Number);
            let sizes = parseInt( elm.getAttribute('sizes').replace(/\S/gm, '') );
            if ( sizes && !widthsArr.includes(sizes) ) widthsArr.push(sizes);
            widthsArr.sort( (a, b) => (a - b) );
            let newSrcSet = '';
            widthsArr.forEach( (size) => {
                newSrcSet += (newSrcSet ? ', ' : '') + newUrl.replace( /(\.[^\.]*)$/gm, '_' + size + 'x$1 ' + size + 'w'); // RegEx selects file extension with dot
            } );

            console.log('window.lizza.replaceMainProductImage replaceImageSource newSrcSet:');
            console.log(newSrcSet);
            elm.setAttribute('srcset', newSrcSet);

        } else if ( elm.hasAttribute('data-src') ) {
            // Change data-src
            let newSrcTemplate = newUrl.replace( /(\.[^\.]*)$/gm, '_{width}x$1'); // RegEx selects file extension with dot

            console.log('window.lizza.replaceMainProductImage newSrcTemplate:');
            console.log(newSrcTemplate);
            elm.setAttribute('data-src', newSrcTemplate);
        } else {
            console.error('window.lizza.replaceMainProductImage: neither srcset, nor data-src attributes presented');
        }

    };

    let replacements = {
        "brownie": "https://cdn.shopify.com/s/files/1/1059/8410/files/Brownie_Product_Image.png?v=1648175545",
        "pizzaboden": "https://cdn.shopify.com/s/files/1/1059/8410/files/Pizza_Product_Image.png?v=1648782898",
        "rustikal-brot-backmischung": "https://cdn.shopify.com/s/files/1/1059/8410/files/Rustical_Brot_Product_Image.png?v=1648782954",
        "mediterran-tassenbrot": "https://cdn.shopify.com/s/files/1/1059/8410/files/Tassenbrot_M_Product_Image.png?v=1648783020",
        "apfel-nuss-tassenkuchen": "https://cdn.shopify.com/s/files/1/1059/8410/files/Tassenkuchen_AN_Product_Image.png?v=1648783134",
        "toast-broetchen": "https://cdn.shopify.com/s/files/1/1059/8410/files/Toast_Brotchen_Product_Images.png?v=1648783315",
        "koernerbrotchen": "https://cdn.shopify.com/s/files/1/1059/8410/files/Kornerbrotchen_PB_Product_Image.png?v=1648783343",
        "apfel-nuss-muesli": "https://cdn.shopify.com/s/files/1/1059/8410/files/Muesli_Apfel_Product_Image.png?v=1648783472",
        "rote-beere-muesli": "https://cdn.shopify.com/s/files/1/1059/8410/files/Muesli_Rote_Beere_Product_Image.png?v=1648783540",
        "pasta-rigatoni": "https://cdn.shopify.com/s/files/1/1059/8410/files/Pasta_Rigatoni_Product_Image.png?v=1648783582",
        "pasta": "https://cdn.shopify.com/s/files/1/1059/8410/files/Pasta_Spirelli_Product_Image.png?v=1648783650",
        "goldleinmehl": "https://cdn.shopify.com/s/files/1/1059/8410/files/Goldleinmehl_Product_Image.png?v=1648783773",
        "koerner-broetchen-backmischung": "https://cdn.shopify.com/s/files/1/1059/8410/files/Kornerbrotchen_BM_Product_Image.png?v=1648783773",
    };

    let productSection = document.querySelector('.product-section');
    if (productSection) {
        let productHandle = productSection.getAttribute('data-product-handle');
        if (productHandle) {
            for (let handle in replacements) {
                if ( Object.prototype.hasOwnProperty.call(replacements, handle) ) {
                    if ( productHandle === handle ) {
                        console.log('window.lizza.replaceMainProductImage: Main code start');

                        let firstImage = document.querySelector('.product__main-photos .product-main-slide:first-child .photoswipe__image');
                        if (firstImage) {
                            let newUrl = replacements[handle];
                            replaceImageSource( firstImage, newUrl );

                            // 2. change data-photoswipe-src
                            let imgHighRes = newUrl.replace( /(\.[^\.]*)$/gm, '_1800x1800$1'); // RegEx selects file extension with dot

                            console.log('window.lizza.replaceMainProductImage imgHighRes:');
                            console.log(imgHighRes);
                            firstImage.setAttribute('data-photoswipe-src', imgHighRes);


                            let firstThumbLink = document.querySelector('.product__thumbs--scroller .product__thumb-item:first-child .product__thumb');
                            if (firstThumbLink) {
                                let firstThumbImg = firstThumbLink.querySelector('img');

                                replaceImageSource( firstThumbImg, newUrl );

                                firstThumbLink.href = imgHighRes;

                            } else {
                                console.error('window.lizza.replaceMainProductImage: could not find first thumb link');
                            }
                        } else {
                            console.error('window.lizza.replaceMainProductImage: could not find first gallery image');
                        }

                    }
                }
            }
        } else {
            console.error('window.lizza.replaceMainProductImage: no productHandle found');
        }
    }

};
if (window.lizza.isGetParameter('food') ) {
    window.lizza.DOMReady(window.lizza.replaceMainProductImage);
}

window.lizza.showProductUSPs = function() {
    let usps_section = document.querySelector('.usps-section');
    if (usps_section) {
        usps_section.classList.remove('hide');
    }
};
if (window.lizza.isGetParameter('usps') ) {
    window.lizza.DOMReady(window.lizza.showProductUSPs);
}
window.lizza.destroyFlickityForUSPsonDesktopWhenLessThan5Icons = function() {
    let usps_section = document.querySelector('.usps-section');
    if (usps_section) {
        // Section is presented on the page
        if (window.theme.sections.instances) {
            // Theme sections initialized
            window.theme.sections.instances.forEach(function(section){
                if ( section.container.classList.contains('usps-section') && section.flickity ) {
                    // USPs section selected from theme sections and flickity is initialized
                    if ( !theme.config.bpSmall && section.flickity.slideshow.slides.length < 5 ) {
                        // It's desktop and we have less than 5 slides
                        section.flickity.destroy();
                    }
                }
            });
        }
    }
};
window.lizza.windowLoad(window.lizza.destroyFlickityForUSPsonDesktopWhenLessThan5Icons);


document.addEventListener('lizza:collection:init', function () {
    var endlessScroll = new Ajaxinate({
        container: '#AjaxinateContainer',
        pagination: '#AjaxinatePagination',
        method: 'scroll',
        offset: 1000,
        callback: window.lizza.ajaxinateCallback
    });
});

/*
* Implemented in GTM on request form Vladimir Mitic
*
* Dmitrii: Logs the time on the site, every 15 seconds
* taken from https://blog.littledata.io/2016/11/13/accurate-tracking-of-time-on-site/
* inspired by https://vutung.com/2019/08/23/how-to-use-timer-in-gtm-to-track-real-time-on-page/
*
* Ported to GTM with help of these articles:
* https://www.simoahava.com/analytics/create-a-generic-event-tag/
* https://www.analyticsmania.com/post/cookies-with-google-tag-manager/
*
* */
/*
(function () {
    var interval_in_seconds = 15; //Run watcher every 15 seconds
    var event_interval_in_seconds = 60 * 5; //Fire event every 5 minutes
    var inFocus = true;
    var sessionStartCookieName = 'lizzaSession';
    var fixedEventsSentCookieName = 'lizzaSessionEventsSent';
    var lastEventSentInSeconds = 0;
    var lizzaFixedSessionEventsArray = [];
    var fnBlur = function(){inFocus = false; };
    var fnFocus = function(){inFocus= true; };
    if (window.addEventListener) {
        window.addEventListener ('blur',fnBlur,true);
        window.addEventListener ('focus',fnFocus,true);
    }
    else if (window.attachEvent) {
        window.attachEvent ('onblur',fnBlur);
        window.attachEvent ('onfocus',fnFocus);
    }
    var roundToNearestN = function( num, n ) {
        if ( !n ) n = interval_in_seconds;
        return Math.round(num / n) * n;
    };
    var formatMS = function(sec){
        var minutes = Math.floor(sec/60);
        var seconds = ('00' + sec%60).slice(-2);
        return minutes +':'+ seconds;
    }
    var sendEvent = function(sec) {
        sec = Math.round(sec);
        var data = {
            'event': 'session_duration',
            'eventCategory': 'engaged user',
            'eventLabel': formatMS(sec),
            'nonInteraction': true
        };
        //console.log('sendEvent:');
        //console.log(data);

        window.dataLayer.push( data );
    };
    var timeLog = window.setInterval(function () {
        var in30Minutes = new Date( new Date().getTime() + 30 * 60 * 1000 );
        var nowTimestamp = new Date().getTime();

        if ( typeof window.Cookies !== 'function' ) {
            console.error(interval_in_seconds + ' seconds interval failed: window.Cookies is not a function');
            return false;
        }

        var sessionStartTime = Cookies.get( sessionStartCookieName );
        if ( ! sessionStartTime ) {
            Cookies.set(sessionStartCookieName, nowTimestamp, {
                expires: in30Minutes
            });
            sessionStartTime = Cookies.get(sessionStartCookieName);
        }

        var fixedEventsString = Cookies.get( fixedEventsSentCookieName );

        var secondsSinceSessionStart = ( nowTimestamp - parseInt(sessionStartTime) ) / 1000;
        secondsSinceSessionStart = roundToNearestN(secondsSinceSessionStart, interval_in_seconds)

        if (inFocus) {
            Cookies.set(sessionStartCookieName, sessionStartTime, {
               expires: in30Minutes
            });
            if ( fixedEventsString ) {
                Cookies.set(fixedEventsSentCookieName, fixedEventsString, {
                    expires: in30Minutes
                });

                lizzaFixedSessionEventsArray = fixedEventsString.split(',');
                lastEventSentInSeconds = Math.max.apply(null, lizzaFixedSessionEventsArray);
            }

            //console.log( secondsSinceSessionStart + ' (' + formatMS(secondsSinceSessionStart) + ')' );
            //console.log( fixedEventsString );

            //sendEvent(secondsSinceSessionStart);
            var nextEventInSeconds = lastEventSentInSeconds + event_interval_in_seconds;

            if ( secondsSinceSessionStart >= nextEventInSeconds ) {
                while ( secondsSinceSessionStart >= nextEventInSeconds ) {
                    sendEvent( nextEventInSeconds );
                    lizzaFixedSessionEventsArray.push( nextEventInSeconds );

                    nextEventInSeconds = nextEventInSeconds + event_interval_in_seconds;
                }

                fixedEventsString = lizzaFixedSessionEventsArray.join(',');

                Cookies.set( fixedEventsSentCookieName, fixedEventsString, {
                    expires: in30Minutes
                });
            }

        } else {
            //console.log('Lizza session outFocus: ' + formatMS(secondsSinceSessionStart));
        }

    }, interval_in_seconds * 1000);
    //window.setTimeout(function () { clearInterval(timeLog); },interval_in_seconds * 1000 * 120); // stop tracking to prevent exceeding Google hits limite
})();
*/

window.lizza.makeFeaturedProductClickableOnHomePage = function() {
    let featuredProductSection = document.querySelector('.template-index .section-featured-product .product-section');
    if (featuredProductSection) {
        let productUrl = featuredProductSection.getAttribute('data-product-url');

        let productTitle = featuredProductSection.querySelector('.h2.product-single__title');
        if (productTitle) {
            let wrapperLink = document.createElement('a');
            wrapperLink.setAttribute('href', productUrl);
            wrapperLink.innerHTML = productTitle.outerHTML;

            productTitle.parentNode.insertBefore(wrapperLink, productTitle);
            productTitle.remove();

            let productImages = featuredProductSection.querySelectorAll('.product-slideshow .product-main-slide');
            let sections = theme.sections.instances;
            sections.forEach(function(section){
                if ( section.container.classList.contains('product-section') ) {
                    // This is the product section, disable flickity drag functionality
                    section.flickity.setDraggable(false);
                }
            });
            productImages.forEach(function(element){
                element.style.cursor = 'pointer';
                element.addEventListener('click', function(){
                    wrapperLink.click();
                });
            });
        }
    }
};
window.lizza.DOMReady(window.lizza.makeFeaturedProductClickableOnHomePage);
